// Iter 105: schemi campi del modulo "Parco risorse" (form + tabella generati dallo schema)
export const QUALIFICHE = [
  { v: "PRE", l: "PRE · Preposto" },
  { v: "PS", l: "PS · Primo soccorso" },
  { v: "EA", l: "EA · Emergenza/Antincendio" },
  { v: "SC", l: "SC · Spazi confinati" },
];

const yn = (v) => (v === false ? "No" : "Sì");
const dateIt = (v) => (v && v.length >= 10 ? `${v.slice(8, 10)}/${v.slice(5, 7)}/${v.slice(0, 4)}` : "");
const opt = (arr) => arr.map(([v, l]) => ({ v, l }));

export const SCHEMAS = {
  esterni: {
    title: "Personale esterno",
    kind: "esterni",
    searchKeys: ["nome", "ditta", "ubicazione", "note"],
    fields: [
      { k: "nome", l: "Nome e cognome", t: "text", req: true, col: true },
      { k: "ditta", l: "Ditta / Agenzia", t: "text", col: true },
      { k: "tipo", l: "Tipo", t: "select", col: true, options: opt([["interinale", "Interinale"], ["artigiano", "Artigiano"], ["ditta_esterna", "Ditta esterna"], ["autonomo", "Autonomo"], ["academy", "Academy / Tirocinio"], ["dipendente_da_verificare", "Dipendente da verificare"]]) },
      { k: "qualifiche", l: "Qualifiche", t: "quals", col: true },
      { k: "patente", l: "Patente", t: "bool", col: true, fmt: yn },
      { k: "contratto_scadenza", l: "Scadenza contratto", t: "date", col: true, fmt: dateIt, scad: true },
      { k: "ubicazione", l: "Ubicazione abituale", t: "sede" },
      { k: "note", l: "Note", t: "textarea", col: true },
      { k: "attivo", l: "Attivo", t: "bool" },
    ],
  },
  mezzi: {
    title: "Mezzi di trasporto",
    kind: "mezzi",
    searchKeys: ["numero_interno", "marca_modello", "targa", "assegnatario", "ubicazione"],
    fields: [
      { k: "numero_interno", l: "N° interno", t: "text", col: true, w: "w-16" },
      { k: "tipo", l: "Tipo", t: "select", col: true, options: opt([["furgone", "Furgone"], ["auto", "Auto"], ["camion", "Camion"], ["semirimorchio", "Semirimorchio"], ["altro", "Altro"]]) },
      { k: "marca_modello", l: "Marca e modello", t: "text", req: true, col: true },
      { k: "targa", l: "Targa", t: "text", col: true, mono: true },
      { k: "assegnatario", l: "Assegnatario", t: "text", col: true },
      { k: "proprieta", l: "Proprietà", t: "select", options: opt([["proprieta", "Di proprietà"], ["noleggio", "Noleggio"], ["leasing", "Leasing"]]) },
      { k: "scad_assicurazione", l: "Scad. assicurazione", t: "date", col: true, fmt: dateIt, scad: true },
      { k: "scad_bollo", l: "Scad. bollo", t: "date", col: true, fmt: dateIt, scad: true },
      { k: "scad_revisione", l: "Scad. revisione", t: "date", col: true, fmt: dateIt, scad: true },
      { k: "ubicazione", l: "Ubicazione", t: "sede", col: true },
      { k: "note", l: "Note", t: "textarea" },
      { k: "attivo", l: "Attivo", t: "bool" },
    ],
  },
  "mezzi-cantiere": {
    title: "Mezzi di cantiere",
    kind: "mezzi-cantiere",
    searchKeys: ["marca_modello", "matricola", "targa", "codice_eg", "fornitore", "ubicazione"],
    fields: [
      { k: "tipo", l: "Tipo", t: "select", col: true, options: opt([["telescopico", "Telescopico"], ["ple", "PLE / Piattaforma"], ["muletto", "Carrello elevatore"], ["gru", "Gru"], ["camion", "Camion"], ["altro", "Altro"]]) },
      { k: "marca_modello", l: "Marca e modello", t: "text", req: true, col: true },
      { k: "matricola", l: "Matricola / n. serie", t: "text", col: true, mono: true },
      { k: "targa", l: "Targa (se targato)", t: "text", mono: true },
      { k: "codice_eg", l: "Codice EG", t: "text", col: true, w: "w-16" },
      { k: "proprieta", l: "Proprietà", t: "select", col: true, options: opt([["proprieta", "Di proprietà"], ["noleggio", "Noleggio"]]) },
      { k: "fornitore", l: "Fornitore noleggio", t: "text" },
      { k: "noleggio_dal", l: "Noleggio dal", t: "date", fmt: dateIt },
      { k: "noleggio_al", l: "Noleggio fino al", t: "date", fmt: dateIt, scad: true },
      { k: "scad_verifica", l: "Scad. verifica periodica", t: "date", col: true, fmt: dateIt, scad: true },
      { k: "scad_assicurazione", l: "Scad. assicurazione", t: "date", fmt: dateIt, scad: true },
      { k: "dotazioni", l: "Dotazioni (FO, V, GsZ…)", t: "text" },
      { k: "stato", l: "Stato", t: "select", col: true, options: opt([["operativo", "Operativo"], ["riparazione", "In riparazione"], ["standby", "Stand-by"]]) },
      { k: "ubicazione", l: "Ubicazione", t: "sede", col: true },
      { k: "note", l: "Note", t: "textarea" },
      { k: "attivo", l: "Attivo", t: "bool" },
    ],
  },
  attrezzature: {
    title: "Attrezzature",
    kind: "attrezzature",
    searchKeys: ["codice", "descrizione", "matricola", "affidatario", "ubicazione"],
    fields: [
      { k: "categoria", l: "Categoria", t: "select", col: true, options: opt([["banco", "Banco"], ["container", "Container"], ["box", "Box / Spogliatoio / Ufficio"], ["quadro_elettrico", "Quadro elettrico"], ["saldatrice", "Saldatrice / Plasma"], ["cisterna", "Cisterna"], ["sollevamento", "Sollevamento"], ["ple", "Trabattello / Piattaforma"], ["scala", "Scale / Rampe"], ["altro", "Altro"]]) },
      { k: "codice", l: "Codice (es. BANCO 7, EG 5)", t: "text", col: true, w: "w-24" },
      { k: "descrizione", l: "Descrizione", t: "text", req: true, col: true },
      { k: "matricola", l: "Matricola", t: "text", col: true, mono: true },
      { k: "quantita", l: "Quantità", t: "number" },
      { k: "affidatario", l: "Affidatario", t: "text", col: true },
      { k: "stato", l: "Stato", t: "select", col: true, options: opt([["operativo", "Operativo"], ["da_affidare", "Da affidare"], ["riparazione", "In riparazione"]]) },
      { k: "scad_verifica", l: "Scad. verifica", t: "date", fmt: dateIt, scad: true },
      { k: "ubicazione", l: "Ubicazione", t: "sede", col: true },
      { k: "note", l: "Note", t: "textarea" },
      { k: "attivo", l: "Attivo", t: "bool" },
    ],
  },
  sedi: {
    title: "Sedi e cantieri",
    kind: "sedi",
    searchKeys: ["nome", "cliente", "pm", "indirizzo", "commesse"],
    fields: [
      { k: "nome", l: "Nome sede / cantiere", t: "text", req: true, col: true },
      { k: "tipo", l: "Tipo", t: "select", col: true, options: opt([["cantiere", "Cantiere"], ["officina", "Officina"], ["deposito", "Deposito"], ["ufficio", "Ufficio"]]) },
      { k: "cliente", l: "Cliente", t: "text", col: true },
      { k: "pm", l: "PM di riferimento", t: "text", col: true },
      { k: "indirizzo", l: "Indirizzo", t: "text", col: true },
      { k: "commesse", l: "Commesse (codici separati da virgola)", t: "list", col: true },
      { k: "alloggio", l: "Alloggio", t: "text" },
      { k: "orario", l: "Orario", t: "text" },
      { k: "stato", l: "Stato", t: "select", col: true, options: opt([["attivo", "Attivo"], ["standby", "Stand-by"], ["futuro", "Futuro"], ["chiuso", "Chiuso"]]) },
      { k: "note", l: "Note", t: "textarea" },
      { k: "attivo", l: "Attivo", t: "bool" },
    ],
  },
};

export const INTERNI_FIELDS = [
  { k: "qualifiche", l: "Qualifiche", t: "quals", col: true },
  { k: "patente", l: "Patente", t: "bool", col: true, fmt: yn },
  { k: "contratto_tipo", l: "Contratto", t: "select", col: true, options: opt([["indeterminato", "Indeterminato"], ["determinato", "Tempo determinato"]]) },
  { k: "contratto_scadenza", l: "Scadenza contratto", t: "date", col: true, fmt: dateIt, scad: true },
  { k: "ubicazione", l: "Ubicazione abituale", t: "sede", col: true },
  { k: "note_programma", l: "Note programma", t: "textarea", col: true },
];

export const emptyFor = (fields) =>
  Object.fromEntries(fields.map((f) => [f.k, f.t === "bool" ? (f.k === "patente" || f.k === "attivo" ? true : false) : f.t === "quals" || f.t === "list" ? [] : f.t === "number" ? 1 : f.t === "select" ? (f.options?.[0]?.v ?? "") : ""]));

export { dateIt };
